import { Observable } from 'rxjs';
import { CadenceViewModel } from '../models';

export type CadenceSubscriptionFactory<
  StackView extends CadenceViewModel,
  Child extends CadenceViewModel,
  Sub = any
> = [(view: StackView) => Observable<any>, (item: any, view: StackView) => any];
